import { ICONS } from '../icons/game-icons.ts';

/**
 * A game-icons.net icon, 1em square in the current text colour, so it sizes and themes like the text
 * around it. `name` comes from a catalog entry (`town.icon`) or the UI table (`UI.market`). Decorative
 * unless given a `label`.
 */
export function Icon({ name, label, className = '' }: { name: string; label?: string; className?: string }) {
  const body = ICONS[name];
  if (!body) {
    if (import.meta.env.DEV) console.warn(`icon "${name}" is not bundled: run \`pnpm --filter @wyn/web icons\``);
    return null;
  }
  return (
    <svg
      viewBox="0 0 512 512"
      className={`icon ${className}`}
      {...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true })}
      // Bodies are static paths from the bundled icon set, never user input.
      dangerouslySetInnerHTML={{ __html: body }}
    />
  );
}
